/**
 * 模块说明：销售中心-销售参数设置-支付方式管理
 */
import { Service } from '@/tools'
export class PayMentServer<T extends TOrder.OrderApiType> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.OrderApiType}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：支付方式设置列表查询
   * /api/order/payment/v1/getList
   */
  getList = <K extends T['ApiGetList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiGetList', data)

  /**
   * 功能：新增支付方式设置
   * /api/order/payment/v1/add
   */
  add = <K extends T['ApiAdd']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：删除支付方式设置
   * /api/order/payment/v1/delete
   */
  delete = <K extends T['ApiDelete']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)

  /**
   * 功能：支付方式设置状态修改
   * /api/order/payment/v1/updateStatus
   */
  updateStatus = <K extends T['ApiUpdateStatus']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateStatus', data)

  /**
   * 功能：编辑支付方式设置
   * /api/order/payment/v1/update
   */
  update = <K extends T['ApiUpdate']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)
  /**
   * 功能：支付方式顺序调整
   * /api/order/payment/v1/updateSort
   */
  updateSort = <K extends T['ApiUpdateSort']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateSort', data)
   /**
   * 功能：支付方式顺序调整
   * /api/order/payment/v1/updateSort
   */
  updateSortDown = <K extends T['ApiUpdateSortDown']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateSortDown', data)
}
